import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { STATUS_OBJECT } from 'src/app/dummy/status';
import { ActivatedRoute, Router } from '@angular/router';
import { PrintService } from 'src/app/services/print.service';
import { TESTING_CENTER } from 'src/app/dummy/tab';
import { COLLECTION_NAME } from 'src/app/dummy/app';
import { BookstoreStore } from 'src/app/stores/bookstore/bookstore.store';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DeleteComponent } from 'src/app/components/delete/delete.component';
import { FireStorageService } from 'src/app/services/fire-storage.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-reading-club',
  templateUrl: './reading-club.component.html',
  styleUrls: ['./reading-club.component.scss']
})
export class ReadingClubComponent implements OnInit {
  @ViewChild('PRINT_TABLE', {static:false}) PRINT_TABLE: ElementRef;
  tabs = TESTING_CENTER.AUDIO_READING;
  DISPLAY_STATUS_KEY: any;
  READING_LEVEL: any[] = [];
  LEVEL_KEY: any = null;

  form: FormGroup;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    public store: BookstoreStore,
    public ps: PrintService,
    private storage: FireStorageService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,

  ) { }

  async ngOnInit() {
    this.form = this.fb.group({
      search: [null, Validators.required]
    })
    this.DISPLAY_STATUS_KEY = STATUS_OBJECT['submitted'];
    this.READING_LEVEL = await this.store.fetchListArray(COLLECTION_NAME.READING_LEVEL, "name");
    this.route.queryParams.subscribe(params => {
      const { level } = params;
      this.LEVEL_KEY = level || null;
      this.store.fetchBookData(COLLECTION_NAME.BOOK_STORE_BOOKS, this.DISPLAY_STATUS_KEY.key, false, this.LEVEL_KEY)
    })
  }

  onCancel(){
    this.form.patchValue({search:null})
    this.store.fetchBookData(COLLECTION_NAME.BOOK_STORE_BOOKS, this.DISPLAY_STATUS_KEY.key, false, this.LEVEL_KEY)
  }
  
  _onSearch(f: any) {
    const { search } = f;
    this.store.fetchBookData(COLLECTION_NAME.BOOK_STORE_BOOKS, this.DISPLAY_STATUS_KEY.key, false, this.LEVEL_KEY, search || null)
  }

  ngDestroy() {
    const { fetchBookDataRef, scrollBookDataRef } = this.store;
    fetchBookDataRef && fetchBookDataRef.unsubscribe();
    scrollBookDataRef && scrollBookDataRef.unsubscribe();
  }

  onSelectedLevel(item?: any) {
    this.router.navigate([`/audio-reading/library`], { queryParams: { level: item.key } });
  }

  onScroll() {
    const { lastVisible } = this.store;
    if (!lastVisible) return;
    this.store.scrollBookData(COLLECTION_NAME.BOOK_STORE_BOOKS, this.DISPLAY_STATUS_KEY.key, false, this.LEVEL_KEY)
  }

  exercise(item: any) {
    this.router.navigate([`/book-store/books/data/0/${item.key}/exercise`], { queryParams: { level: this.LEVEL_KEY } })
  }


  create(item?: any) {
    this.router.navigate([`/audio-reading/library/0/${item ? item.key : 'draft'}`], { queryParams: { level: this.LEVEL_KEY } })
  }

  delete(item: any) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      data: { title: 'Delete Book', memo: 'Document will delete from you and student.', name: item.name },
      width: '35vw',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        try {
          const { audioFileDetail, bookFileDetail, coverFileName } = item;
          if (bookFileDetail.filename) {
            this.storage.storageRef(bookFileDetail.filename).delete();
          }
          audioFileDetail.forEach(m => {
            this.storage.storageRef(m.filename).delete();
          })
          coverFileName.forEach(m => {
            this.storage.storageRef(m.filename).delete();
          })
        } catch (error) {
        }
        this.store.deleteItem(COLLECTION_NAME.BOOK_STORE_BOOKS, item, (success, res) => {
          this.snackBar.open("Audio reading has been deleted successful.", "Done", { duration: 1000 });
        })
      }
    });
  }

}
